module.exports = __webpack_public_path__ + "img/alert.269365b5.svg";